

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SessionReflectionsProps {
  learned?: string;
  improvements?: string;
  successes?: string;
  notes?: string;
}

export function SessionReflections({
  learned,
  improvements,
  successes,
  notes,
}: SessionReflectionsProps) {
  // Fallback to notes if none of the reflections are present
  if (!learned && !improvements && !successes && notes) {
    return (
      <div className="grid gap-4 mt-2">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Notes</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-sm">{notes}</CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="grid gap-4 mt-2">
      {learned && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">What I Learned</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-sm">{learned}</CardContent>
        </Card>
      )}
      {improvements && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Areas for Improvement</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-sm">{improvements}</CardContent>
        </Card>
      )}
      {successes && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">What Went Well</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-sm">{successes}</CardContent>
        </Card>
      )}
    </div>
  );
}
